import React from 'react'
import { mdiSkull } from '@mdi/js'

export default function Icon({
  path = mdiSkull,
  spinning = false,
  large = false,
  className = '',
  bare = false,
  viewBox = '0 0 21 21',
}) {
  const classNames = ['svg-icon']
  if (spinning) classNames.push('spinning')
  if (large) classNames.push('large')
  if (bare) classNames.push(className)

  const svgEl = (
    <svg viewBox={viewBox} className={classNames.join(' ')}>
      <path d={path} />
    </svg>
  )

  if (bare) {
    return svgEl
  }

  return (
    <span className={className}>
      {svgEl}
      &nbsp;
    </span>
  )
}
